export const isRecord = (obj: unknown): obj is Record<any, any> => {
  if (obj == null) {
    return false
  }
  if (typeof obj !== 'object') {
    return false
  }
  return !Array.isArray(obj);
}
